import React from 'react'
import connect from 'front-end-core/decorators/connect'
import {
  requestEventTypes,
  requestListDeals,
  getDocumentConfiguration
} from 'services/DealwatchService'
import ResponseConsumer from 'pages/share/Main'
import ListDeals from 'pages/mwlistdeals/ListDeals'

const ListDealsWrapper = connect(({ dealType, pageNumber, pageSize, parameters, searchPhrase }) => ({
  eventTypes: requestEventTypes(),
  deals: requestListDeals({
    eventType: dealType,
    page: pageNumber,
    searchPhrase,
    pageSize,
    parameters
  }),
  documentConfiguration: getDocumentConfiguration()
}))(props => {
  const {
    eventTypes,
    deals,
    documentConfiguration
  } = props
  return (
    <ResponseConsumer
      responses={[
        eventTypes,
        deals,
        documentConfiguration
      ]}
      content={() => <ListDeals {...props} />}
    />
  )
})

export default ListDealsWrapper
